import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { checkoutAddPath, CheckoutAddUrlQueryParams } from "./urls";
import CheckoutAddComponent from "./views/CheckoutAdd";

const checkoutAdd: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: CheckoutAddUrlQueryParams = qs;
  return <CheckoutAddComponent params={params} />;
};
export const CheckoutAddSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.checkoutAdd)} />
      <Switch>
        <Route exact path={checkoutAddPath} component={checkoutAdd} />
      </Switch>
    </>
  );
};
export default CheckoutAddSection;
